import type { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

export const BoxLayout: FC<PropsWithChildren<{ title?: string }>> = ({ children, title }) => {
  return (
    <Container>
      {title && <BoxHeader>{title}</BoxHeader>}
      {children}
    </Container>
  );
};

const BoxHeader = styled.h3`
  margin: 1.3em 0 0.7em 0.5em;
  font-size: 1.1em;
  font-weight: normal;
  color: ${({ theme }): string => theme.palette.secondary.light};
`;

const Container = styled.div`
  margin: 1em 0;
  @media (width < 100rem) {
    margin: 0.5em 0;
  }
`;
